import React, { useEffect, useMemo, useState } from "react";
import {
  Accordion,
  Button,
  Card,
  Form,
  FormControl,
  InputGroup,
  Offcanvas,
  useAccordionButton,
} from "react-bootstrap";
import PlaceOrder from "assets/svgs/placeorder";
import ItemCounter from "./ItemCounter";
import ReactSelect from "react-select";
import { placeOrderData } from "./service";
import PlacedOrderForm from "./PlaceOrderForm";
import { useToast } from "modules/navbar/top/store/toasterStore";
import {
  ALL_ORDER_PLACE_FLAG,
  currentUser,
  customDiscountAndZeroValueOrderEmails,
  customLeadDiscount,
  getCurrentUserRole,
  LEAD_AGENT,
  orderedProducts,
  roles,
  ROLES_NAME,
  THIRD_PARTY_MEDREPS,
} from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";
import { Tooltip } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import ZeroValueOrder from "./ZeroValueOrder";
import CustomDiscount from "./CustomDiscount";
import {
  useProductMapping,
  useGenerateCartLink,
  useCODOrder,
  useCustomer,
  useMonthKitData,
  useFreshChatData,
} from "./store";
import {
  totalPriceCalculated,
  itemList,
  updatedDiscounts,
  invalidStatuses,
} from "modules/utilities/utility";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FirstMonthMedicineModal from "./FirstMonthMedicineModal";
import LeadDiscount from "./LeadDiscount";
import { get, isEmpty } from "lodash";
import secureLocalStorage from "react-secure-storage";
import { getUserProfile } from "modules/navbar/top/api";
import { useSetChat } from "modules/nextcall/store";
import OmsComponent from "./OmsComponent";
import { OMS_ACCESS } from "modules/utilities/utility_2";

function ProductsOffcanvas({
  customerName,
  orderCount,
  user,
  address,
  case_id,
  billingAddress,
}) {
  const { customerData } = useCustomer();
  const { kitData, fetchMonthKitData } = useMonthKitData();
  const { productCanvas, setProductCanvas } = useGenerateCartLink();
  const { setToaster } = useToast();
  const { productsData, fetchProducts } = useProductMapping();
  const [showCopy, setShowCopy] = useState();
  const { isLoading, isError, errorMessage, createCODOrder } = useCODOrder();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [discountValue, setDiscountValue] = useState(0);
  const [orderLink, setOrderLink] = useState();
  const [copyButton, setCopyButton] = useState("Copy");
  const [customerDetails, setCustomerAddress] = useState();
  const [placeOrderStatus, setPlaceOrderStatus] = useState();
  const [canSubmit, setCanSubmit] = useState(true);
  const [category, setCategory] = useState("");
  const [isZeroValueOrder, setIsZeroValueOrder] = useState(false);
  const [customDiscountType, setCustomDiscountType] = useState("value");
  const [customDiscountAmount, setCustomDiscountAmount] = useState(0);
  const [isCustomDiscount, setIsCustomDiscount] = useState(false);
  const [show, setShow] = useState(false);
  const [zeroValueOrder, setZeroValueOrder] = useState({
    is_zero_value_order: false,
    zero_value_order_comment: "",
    previous_order_id: "",
    category: "",
    reason: "",
  });
  const [copyCart, setCopyCart] = useState();
  const [isFirstModalVisible, setFirstModalVisible] = useState(false);
  const [isThreeModalVisible, setThreeModalVisible] = useState(false);
  const [isSecondModalVisible, setSecondModalVisible] = useState(false);
  const [mappedProduct, setMappedProduct] = useState([]);
  const [changeFlag, setChangeFlag] = useState(false);
  const [discountCode, setDiscountCode] = useState(null);
  const [subFlag, setSubFlag] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [omsFlag, setOmsFlag] = useState(false);
  const customDiscountAccess = ["super_admin", "lead_agent", "chat" , "clinic_receptionist", 'ivr'];
  const levelAccess = [1, 2, 4, 5];
  const userLevel = secureLocalStorage.getItem("level");
  const { setChatMessage } = useSetChat();
  const { fetchFreshChatData } = useFreshChatData();
  
  const saleDiscounts = [
    {
      label: "RTGRP30",
      value: "RTGRP30",
      code: "RTGRP30",
      amount: 30,
      type: "percentage",
    },
  ];

  const mappedFirstMed = useMemo(() => {
    return kitData?.nextMonthProductDetails?.map((item) => {
      return { name: item?.name, quantity: item?.quantity?._1month };
    });
  }, [kitData]);

  const mappedThirdMed = useMemo(() => {
    return kitData?.nextMonthProductDetails?.map((item) => {
      return { name: item?.name, quantity: item?.quantity?._3month };
    });
  }, [kitData]);

  const mappedSecondMed = useMemo(() => {
    return kitData?.nextMonthProductDetails?.map((item) => {
      return { name: item?.name, quantity: item?.quantity?._2month };
    });
  }, [kitData]);

  const getValidOrderCount = (orders) => {
    if (!Array.isArray(orders)) return 0;
    if (orders.length < 1) return 0;

    let _orders = [];
    _orders = orders.filter((item) => invalidStatuses.has(item.status));
    return orders.length - _orders.length;
  };

  useEffect(() => {
    setPlaceOrderStatus({
      text: "Place COD Order",
      variant: "success",
    });
    setCustomerAddress({
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phone: user.phone_number,
      address1: address?.address1,
      address2: address?.address2,
      city: address?.city,
      province: address?.province,
      zip: address?.zip,
      country: address?.country,
    });
    setCart({});
    setTotalPrice(0);
    setSelectedDiscount(null);
    setDiscountValue(0);
    setOrderLink(null);
    setCopyCart(null);
  }, [case_id, address]);

  useEffect(() => {
    if (show) {
      isEmpty(productsData) && fetchProducts();
    }
  }, [show]);

  useEffect(() => {
    if (productsData.length) {
      const filteredProducts = orderedProducts(customerData, productsData, kitData);
      setProducts(filteredProducts);
    }
  }, [productsData, customerData, kitData]);

  useEffect(() => {
    const data = products?.map((item) => {
      return {
        display_name: item?.medicine?.display_name,
        product_price: item?.product_price,
        product_principal_id: item?.product_principal_id,
        quantity: 0,
      };
    });
    setMappedProduct(data);
  }, [products, changeFlag]);

  useEffect(() => {
    if(show){
      handleGenerateLink();
      setShowCopy();
      if (autoApply && orderCount) {
        if (totalPrice < 1500) {
          !isCustomDiscount && setDiscountValue(0);
          !isCustomDiscount && setSelectedDiscount(null);
        } else if (totalPrice >= 1500 && totalPrice < 2400) {
          !isCustomDiscount && setSelectedDiscount(updatedDiscounts[0]);
          !isCustomDiscount && setDiscountValue(updatedDiscounts[0].amount);
        } else if (totalPrice >= 2400 && totalPrice < 4000) {
          !isCustomDiscount && setSelectedDiscount(updatedDiscounts[1]);
          !isCustomDiscount && setDiscountValue(updatedDiscounts[1].amount);
        } else if (totalPrice >= 4000) {
          !isCustomDiscount && setSelectedDiscount(updatedDiscounts[2]);
          !isCustomDiscount && setDiscountValue(updatedDiscounts[2].amount);
        }
      }
    }
  }, [totalPrice, isCustomDiscount, show]);

  const autoApply = true;
  const handleClose = () => {
    setTotalPrice(0);
    setSelectedDiscount(null);
    setDiscountValue(0);
    setOrderLink(null);
    setCopyCart(null);
    setCopyButton("Copy");
    PlaceOrder(null);
    setShow(false);
    setCart({});
    setProductCanvas(false);
    setZeroValueOrder({
      is_zero_value_order: false,
      zero_value_order_comment: "",
      previous_order_id: "",
      category: "",
      reason: "",
    });
    setIsZeroValueOrder(false);
    setDiscountCode(null);
    setSubFlag(false);
    setSelectedCountry(null);
    setOmsFlag(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchMonthKitData(case_id);
    setChangeFlag(!changeFlag);
  };
  useEffect(() => {
    if (productCanvas) {
      handleShow();
    }
  }, [productCanvas]);

  useEffect(() => {
    let cart = mappedProduct.reduce((prev, curr) => {
      if (!prev?.product_principal_id && curr?.quantity) {
        prev[curr?.product_principal_id] = curr?.quantity;
      }
      return prev;
    }, {});
    setCart(cart);
  }, [mappedProduct]);

  //keep it commented due to future need
  // const handleAddToCart = (productName, count) => {
  //   const updatedCart = { ...cart };

  //   if (count === 0) {
  //     delete updatedCart[productName];
  //   } else {
  //     updatedCart[productName] = count;
  //   }

  //   setCart(updatedCart);
  //   setTotalPrice(
  //     Object.entries(updatedCart).reduce(
  //       (total, [productName, count]) =>
  //         total +
  //           count *
  //             products.find(
  //               (product) => product.product_principal_id === productName
  //             )?.product_price || 0,
  //       0
  //     )
  //   );
  // };
  const handleGenerateLink = async () => {
    try {
      const response = await getUserProfile();
      const userData = response.data;

      if (!userData || !userData.userName) {
        console.error("Failed to get user data from profile API");
        return;
      }

      const formattedUserName = userData?.userName
        ?.toLowerCase()
        .replace(" ", "_");

      const link =
        "https://traya.health/pages/Result-repeat?items=" +
        itemList(cart) +
        "&utm_medium=hair_expert&utm_source=direct&utm_campaign=" +
        formattedUserName +
        "&customer_name=" +
        customerName.toLowerCase().replace(/ /g, "_") +
        (selectedDiscount ? `&discount=${selectedDiscount.code}` : "") +
        "&order_count=" +
        getValidOrderCount(customerData.orders) +
        (selectedDiscount
          ? `&discount_value=${selectedDiscount.amount}&discount_type=${selectedDiscount.type}`
          : "");

      const cartLink =
        "https://form.traya.health/recommendedcart" +
        `/${case_id}` +
        "?utm_medium=hair_expert&utm_source=direct&utm_campaign=" +
        formattedUserName;

      setOrderLink(link);
      setCopyCart(cartLink);
    } catch (error) {
      console.error("Error generating link:", error);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      background: "white",
    }),
  };

  const handleCopyOrderLink = () => {
    navigator.clipboard
      .writeText(copyCart)
      .then(() => {
        setCopyButton(<span className="text-success">Copied</span>);
        setTimeout(() => {
          setCopyButton("Copy");
        }, 3000);
      })
      .catch((error) => {
        setCopyButton(<span className="text-danger">Failed to Copy</span>);
        setTimeout(() => {
          setCopyButton("Copy");
        }, 3000);
      });
  };

  const handleCustomerDetailChanges = (field, value) => {
    setCustomerAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value,
    }));
  };

  const handleDiscountChange = (selectedOption) => {
    setSelectedDiscount(selectedOption);
    setDiscountValue(selectedOption ? selectedOption.amount : 0);
  };
  // "address1"
  const handleSubmit = (event) => {
    event.preventDefault();
    let cartData = cart;
    //Added  a check for minoxidil and minoxidil tablet because agent can select both a time
    const duplicateData = [
      "43924864598194",
      "37547358453938",
      "37997006225586",
      "40624818257968",
      "41407549177904",
      "44247665213618",
      "44247595024562",
    ];
    let productCount = 0;
    Object.entries(cartData).forEach(([id, count]) => {
      if (duplicateData.includes(id)) {
        productCount += 1;
      }
    });

    if (productCount > 1 && !ALL_ORDER_PLACE_FLAG ) {
      toast.info(
        "You can only add one item at a time. Please select either minoxidil or minoxidil tablet or Alcohol-free-minoxidil"
      );
      return;
    }
    const customerOrders = get(customerData, "orders", []);
    const isNonVoidOrder = customerOrders.some((order) => order.status !== "void");

    if(!isNonVoidOrder && user.gender === 'F' && !cartData['44650256728242']){
      cartData['45277154377906'] = 1;
    }

    const priceData = totalPriceCalculated(
      totalPrice,
      selectedDiscount?.amount,
      selectedDiscount?.type
    );

    setChangeFlag(!changeFlag);

    if (priceData > 5000) {
      toast.warning("you can not Select Cart value more than 5000rs");
      return;
    }
    if (customerDetails?.address1?.length <= 30) {
      return;
    }
    const customerDetailsData = {
      ...customerDetails,
      phone: user.phone_number,
      email: user.email,
    };
    createCODOrder(
      placeOrderData(
        case_id,
        cartData,
        customerDetailsData,
        [selectedDiscount],
        zeroValueOrder,
        billingAddress,
        omsFlag,
        selectedCountry
      ),
      setToaster
    );
    handleClose();
  };

  const handleFirstClickSave = () => {
    setFirstModalVisible(!isFirstModalVisible);
    const data = mappedProduct?.map((item) => {
      const matchingProduct = kitData?.nextMonthProductDetails?.find(
        (inItem) => inItem?.product_id === item?.product_principal_id
      );
      if (matchingProduct) {
        return {
          display_name: matchingProduct?.name,
          product_price: matchingProduct?.price,
          product_principal_id: matchingProduct?.product_id,
          quantity: matchingProduct?.quantity?._1month,
        };
      } else {
        return item;
      }
    });
    setMappedProduct(data);
  };
  const handleThreeClickSave = () => {
    setThreeModalVisible(!isThreeModalVisible);
    const data = mappedProduct?.map((item) => {
      const matchingProduct = kitData?.nextMonthProductDetails?.find(
        (inItem) => inItem?.product_id === item?.product_principal_id
      );

      if (matchingProduct) {
        return {
          display_name: matchingProduct?.name,
          product_price: matchingProduct?.price,
          product_principal_id: matchingProduct?.product_id,
          quantity: matchingProduct?.quantity?._3month,
        };
      } else {
        return item;
      }
    });
    setMappedProduct(data);
  };

  const handleTwoClickSave = () => {
    const message = "two_month_kit_link_v2";
    setChatMessage(case_id, message, fetchFreshChatData);
    setSecondModalVisible(false);
  };

  useEffect(() => {
    const calculateTotalPrice = () => {
      const price = mappedProduct?.reduce((total, product) => {
        return total + product.quantity * parseFloat(product.product_price);
      }, 0);
      setTotalPrice(price);
    };
    calculateTotalPrice();
  }, [mappedProduct]);

  const handleIncrement = (productId) => {
    const updatedProducts = mappedProduct?.map((product) => {
      if (product.product_principal_id == productId) {
        return { ...product, quantity: product.quantity + 1 };
      }
      return product;
    });
    setMappedProduct(updatedProducts);
  };

  const handleDecrement = (productId) => {
    const updatedProducts = mappedProduct?.map((product) => {
      if (product.product_principal_id === productId && product.quantity > 0) {
        return { ...product, quantity: product.quantity - 1 };
      }
      return product;
    });
    setMappedProduct(updatedProducts);
  };

  return (
    <>
      <Tooltip title="Place Order">
        <Button style={{ flex: 1 }} className="py-2 ms-2" onClick={handleShow}>
          Place Order <PlaceOrder />
        </Button>
      </Tooltip>

      <Offcanvas
        style={{ width: "56vw", Index: 1019 }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="d-flex gap-2 align-items-center ms-3">
              <div className="fw-bold">Recommended Cart{"  "}:</div>
              <div className="d-flex gap-3 ms-3">
                <button
                  className="btn btn-info"
                  onClick={() => setFirstModalVisible(!isFirstModalVisible)}
                >
                  One Month Kit
                </button>
                {LEAD_AGENT.includes(currentUser) && (
                  <button
                    className="btn btn-info"
                    onClick={() => setSecondModalVisible(!isSecondModalVisible)}
                  >
                    Two Month Kit
                  </button>
                )}
                <button
                  className="btn btn-info"
                  onClick={() => setThreeModalVisible(!isThreeModalVisible)}
                >
                  Three Month Kit
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setChangeFlag(!changeFlag)}
                >
                  Clear
                </button>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="scrollable-section mt-n4">
          <div
            style={{ top: 0, zIndex: "9" }}
            className="d-flex justify-content-between align-items-center border rounded p-2 px-3 mb-3 mx-3 mt-n2 fw-bold shadow position-sticky bg-white"
          >
            <div className="flex-1">
              Total Price :{" "}
              <span className="text-success">{"₹ " + totalPrice}</span>
            </div>
            <div
              className={
                orderCount || isZeroValueOrder || isCustomDiscount
                  ? "flex-1"
                  : "d-none"
              }
            >
              Discount Value :{" "}
              <span className="text-success">
                {selectedDiscount?.amount}
                {selectedDiscount?.type
                  ? selectedDiscount.type === "percentage"
                    ? "%"
                    : "₹ "
                  : ""}
              </span>
            </div>
            <div
              className={
                orderCount || isZeroValueOrder || isCustomDiscount
                  ? "flex-1"
                  : "d-none"
              }
            >
              Cart Value :{" "}
              {console.log(
                "I am selected discount inside cart value",
                selectedDiscount
              )}
              <span className="text-success">
                {"₹ " +
                  totalPriceCalculated(
                    totalPrice,
                    selectedDiscount?.amount,
                    selectedDiscount?.type
                  )}
              </span>
            </div>
            {orderCount ? (
              <div>
                {autoApply ? (
                  <InputGroup className="flex-1">
                    <InputGroup.Text id="basic-addon1">
                      Discount Applied
                    </InputGroup.Text>
                    <FormControl
                      value={discountValue ? selectedDiscount?.label : "NONE"}
                      disabled
                      className={`${
                        discountValue ? `text-success` : `text-secondary`
                      } text-center fw-bold`}
                      aria-describedby="basic-addon1"
                    />
                  </InputGroup>
                ) : (
                  <div className="flex-1">
                    <ReactSelect
                      options={updatedDiscounts}
                      styles={customStyles}
                      value={selectedDiscount}
                      onChange={handleDiscountChange}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="d-none"></div>
            )}
          </div>
          <div
            style={{ maxHeight: "50%", minHeight: "40%" }}
            className="border rounded mx-3 overflow-scroll shadow p-1 scrollable-container"
          >
            <div className="grid-container">
              {mappedProduct.length > 0 &&
                mappedProduct
                  .filter(
                    (product) =>
                      !["7684826824882", "7684825645234"].includes(
                        product?.product_principal_id
                      )
                  )
                  .map((product) => (
                    <div
                      style={{ fontSize: 10 }}
                      className={`p-3 px-2 mx-0 border rounded d-flex justify-content-around shadow align-items-start fw-bold ${
                        product?.quantity !== 0
                          ? "success-light border-success"
                          : ""
                      }`}
                      key={product.product_principal_id}
                    >
                      <span className="flex-4">
                        {product.display_name.includes("Alcohol-free")
                          ? product.display_name.split(",").reverse().join(",")
                          : product?.display_name}
                      </span>
                      <div className="flex-4">
                        <div className="mx-2">
                          <InputGroup size="sm">
                            <button
                              disabled={!product?.quantity}
                              className="px-1 border rounded-left"
                              onClick={() =>
                                handleDecrement(product?.product_principal_id)
                              }
                            >
                              -
                            </button>
                            <Form.Control
                              disabled
                              className="text-center px-2 input-spin-none"
                              type="number"
                              min="0"
                              style={{ width: "25px" }}
                              value={product?.quantity}
                            />
                            <button
                              className="px-1 border rounded-right"
                              onClick={() =>
                                handleIncrement(product?.product_principal_id)
                              }
                            >
                              +
                            </button>
                          </InputGroup>
                        </div>
                      </div>
                      <span className="flex-3 text-end text-success">
                        {"₹ " +
                          (product?.quantity
                            ? product?.product_price * product?.quantity
                            : product?.product_price)}
                      </span>
                    </div>
                  ))}
            </div>
          </div>
          {customDiscountAndZeroValueOrderEmails.includes(
            secureLocalStorage.getItem("email")
          ) && (
            <div style={{ minHeight: "12%" }} className="m-2">
              <CardDiv
                component={
                  <div>
                    <ZeroValueOrder
                      category={category}
                      setCategory={setCategory}
                      setCanSubmit={setCanSubmit}
                      zeroValueOrder={zeroValueOrder}
                      isZeroValueOrder={isZeroValueOrder}
                      setZeroValueOrder={setZeroValueOrder}
                      setIsCustomDiscount={setIsCustomDiscount}
                      setSelectedDiscount={setSelectedDiscount}
                      setIsZeroValueOrder={setIsZeroValueOrder}
                    />
                    {!isZeroValueOrder && (
                      <CustomDiscount
                        isCustomDiscount={isCustomDiscount} //
                        setDiscountValue={setDiscountValue}
                        customDiscountType={customDiscountType}
                        setIsCustomDiscount={setIsCustomDiscount} //
                        setSelectedDiscount={setSelectedDiscount} //
                        customDiscountAmount={customDiscountAmount}
                        setCustomDiscountType={setCustomDiscountType}
                        setCustomDiscountAmount={setCustomDiscountAmount}
                      />
                    )}
                  </div>
                }
              />
            </div>
          )}
          {/* {OMS_ACCESS && <div>
            <OmsComponent setSelectedCountry={setSelectedCountry} omsFlag ={omsFlag} setOmsFlag={setOmsFlag} />
          </div>} */}
          {((customDiscountAccess.includes(currentUser) &&
            levelAccess.includes(userLevel)) ||
            customLeadDiscount.includes(secureLocalStorage.getItem("email")) ) && (
            <div style={{ minHeight: "12%" }} className="m-2">
              <CardDiv
                component={
                  <div>
                    <LeadDiscount
                      setDiscountValue={setDiscountValue}
                      setIsCustomDiscount={setIsCustomDiscount}
                      setSelectedDiscount={setSelectedDiscount}
                      totalPrice={totalPrice}
                      discountCode={discountCode}
                      setDiscountCode={setDiscountCode}
                      subFlag={subFlag}
                      setSubFlag={setSubFlag}
                    />
                  </div>
                }
              />
            </div>
          )}

          <PlacedOrderForm
            cart={cart}
            setShow={setShow}
            isError={isError}
            case_id={case_id}
            showCopy={showCopy}
            canSubmit={canSubmit}
            isLoading={isLoading}
            orderLink={orderLink}
            copyButton={copyButton}
            setToaster={setToaster}
            setShowCopy={setShowCopy}
            errorMessage={errorMessage}
            handleSubmit={handleSubmit}
            customerDetails={customerDetails}
            placeOrderStatus={placeOrderStatus}
            handleCopyOrderLink={handleCopyOrderLink}
            cartValue={totalPriceCalculated(
              totalPrice,
              discountValue,
              selectedDiscount?.type
            )}
            handleCustomerDetailChanges={handleCustomerDetailChanges}
          />
          <FirstMonthMedicineModal
            isModalVisible={isFirstModalVisible}
            setIsModalVisible={setFirstModalVisible}
            mappedData={mappedFirstMed}
            handleOnClick={handleFirstClickSave}
            firstMonth={true}
          />
          <FirstMonthMedicineModal
            isModalVisible={isThreeModalVisible}
            setIsModalVisible={setThreeModalVisible}
            mappedData={mappedThirdMed}
            handleOnClick={handleThreeClickSave}
            firstMonth={false}
          />
          <FirstMonthMedicineModal
            isModalVisible={isSecondModalVisible}
            setIsModalVisible={setSecondModalVisible}
            mappedData={mappedSecondMed}
            handleOnClick={handleTwoClickSave}
            firstMonth="Two"
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ProductsOffcanvas;
